/**
 * PathLine — animated SVG connector between process steps.
 *
 * Renders an SVG line that draws itself in (pathLength 0 → 1) when scrolled
 * into view. Used between cards in "For Startups / Investors" flows.
 *
 *   <PathLine className="absolute top-1/2 left-0 w-full h-px" />
 */
import { motion } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";

export const PathLine = ({
  d = "M 0 0.5 L 100 0.5",
  className,
  color = "#E8DDD4",
  strokeWidth = 1,
  duration = 1.2,
  delay = 0,
}) => {
  const reduced = usePreferStaticUI();
  return (
    <svg
      className={className}
      preserveAspectRatio="none"
      viewBox="0 0 100 1"
      aria-hidden="true"
    >
      <motion.path
        d={d}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        fill="none"
        initial={reduced ? { pathLength: 1 } : { pathLength: 0 }}
        whileInView={{ pathLength: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: reduced ? 0 : duration, ease: "easeInOut", delay }}
      />
    </svg>
  );
};

export default PathLine;
